import { SourceFieldConfig } from 'apis/restaurant-api/merchant-admin/menu2/types';

export const csvColumnsTranslationMap = {
  item_id: 'menu.csvItemColumnName.item_id',
  gtin: 'menu.csvItemColumnName.gtin',
  merchant_sku: 'menu.csvItemColumnName.merchant_sku',
  name: 'menu.csvItemColumnName.name',
  brand_id: 'menu.csvItemColumnName.brand_id',
  caffeine_content_value: 'menu.csvItemColumnName.caffeine_content_value',
  caffeine_content_units: 'menu.csvItemColumnName.caffeine_content_units',
  description: 'menu.csvItemColumnName.description',
  image_url: 'menu.csvItemColumnName.image_url',
  dietary_preferences: 'menu.csvItemColumnName.dietary_preferences',
  product_hierarchy_id: 'menu.csvItemColumnName.product_hierarchy_id',
  product_hierarchy_name: 'menu-item.product-hierarchy',
  price: 'menu.csvItemColumnName.price',
  discounted_price: 'menu.csvItemColumnName.discounted_price',
  return_policy: 'menu.csvItemColumnName.return_policy',
  weight_in_grams: 'menu.csvItemColumnName.weight_in_grams',
  volume_in_ml: 'menu.csvItemColumnName.volume_in_ml',
  number_of_units: 'menu.csvItemColumnName.number_of_units',
  display_unit: 'menu.csvItemColumnName.display_unit',
  weighted_item_sell_by: 'menu.csvItemColumnName.weighted_item_sell_by',
  weighted_item_approx_weight_in_grams: 'menu.csvItemColumnName.weighted_item_approx_weight_in_grams',
  weighted_item_min_weight_in_grams: 'menu.csvItemColumnName.weighted_item_min_weight_in_grams',
  vat_percentage: 'menu.csvItemColumnName.vat_percentage',
  alcohol_percentage: 'menu.csvItemColumnName.alcohol_percentage',
  pos_id: 'menu.csvItemColumnName.pos_id',
  country_of_origin: 'menu.csvItemColumnName.country_of_origin',
  ingredients: 'menu.csvItemColumnName.ingredients',
  additives: 'menu.csvItemColumnName.additives',
  nutrition_facts: 'menu.csvItemColumnName.nutritional_information',
  allergens: 'menu.csvItemColumnName.allergens',
  conditions_of_use_and_storage: 'menu.csvItemColumnName.conditions_of_use_and_storage',
  more_information: 'menu.csvItemColumnName.more_information',
  mandatory_warnings: 'menu.csvItemColumnName.mandatory_warnings',
  distributor_information: 'menu.csvItemColumnName.distributor_information',
  deposit_value: 'menu.csvItemColumnName.deposit_value',
  deposit_vat: 'menu.csvItemColumnName.deposit_vat',
  producer_information: 'menu.csvItemColumnName.producer_information',
  enabled: 'menu.csvItemColumnName.enabled',
  is_age_restricted_item: 'menu.csvItemColumnName.is_age_restricted_item',
  age_limit: 'menu.csvItemColumnName.age_limit',
  is_over_the_counter: 'menu.csvItemColumnName.is_over_the_counter',
  delivery_handshake: 'menu.csvItemColumnName.delivery_handshake',
  min_quantity_per_purchase: 'menu.csvItemColumnName.min_quantity_per_purchase',
  max_quantity_per_purchase: 'menu.csvItemColumnName.max_quantity_per_purchase',
  use_limited_quantity: 'menu.csvItemColumnName.use_limited_quantity',
  use_inventory_management: 'menu.csvItemColumnName.use_inventory_management',
  is_in_stock: 'menu.csvItemColumnName.is_in_stock',
  item_balance: 'menu.csvItemColumnName.item_balance',
  location: 'menu.csvItemColumnName.location',
  commission_delivery: 'menu.csvItemColumnName.commission_delivery',
  commission_pickup: 'menu.csvItemColumnName.commission_pickup',
  category_id: 'menu.csvItemColumnName.category_id',
  category_name: 'menu.csvItemColumnName.category_name',
  category_item_sequence: 'menu.csvItemColumnName.category_item_sequence',
  picking_area: 'menu.csvItemColumnName.picking_area',
  picking_sequence: 'menu.csvItemColumnName.picking_sequence',
};

type CSVColumnKey = keyof typeof csvColumnsTranslationMap;

export const identicationColumns: CSVColumnKey[] = ['item_id', 'gtin', 'merchant_sku'];

export const UNASSIGNED_AREA_ID = '00000000-0000-0000-0000-000000000000';

export const csvColumnToSourceFieldConfigMap: Record<CSVColumnKey, keyof SourceFieldConfig | null> = {
  item_id: null,
  gtin: null,
  merchant_sku: null,
  name: 'name',
  brand_id: 'brand_id',
  caffeine_content_units: null,
  caffeine_content_value: null,
  description: 'description',
  image_url: 'images',
  dietary_preferences: 'dietary_preferences',
  product_hierarchy_id: 'product_hierarchy_level_id',
  product_hierarchy_name: null,
  price: null,
  discounted_price: null,
  weight_in_grams: 'weight_in_grams',
  volume_in_ml: 'volume_in_ml',
  number_of_units: 'number_of_units',
  display_unit: 'display_unit',
  weighted_item_sell_by: null,
  weighted_item_approx_weight_in_grams: null,
  weighted_item_min_weight_in_grams: null,
  vat_percentage: null,
  alcohol_percentage: 'alcohol_percentage',
  pos_id: null,
  country_of_origin: 'country_of_origin',
  ingredients: 'ingredients',
  additives: 'additives',
  nutrition_facts: 'nutrition_facts',
  allergens: 'allergens',
  conditions_of_use_and_storage: 'conditions_of_use_and_storage',
  more_information: 'more_information',
  mandatory_warnings: 'mandatory_warnings',
  distributor_information: 'distributor_information',
  deposit_value: null,
  deposit_vat: null,
  producer_information: 'producer_information',
  enabled: null,
  is_age_restricted_item: null,
  delivery_handshake: null,
  age_limit: null,
  is_over_the_counter: null,
  min_quantity_per_purchase: null,
  max_quantity_per_purchase: null,
  use_limited_quantity: null,
  use_inventory_management: null,
  is_in_stock: null,
  item_balance: null,
  location: null,
  commission_delivery: null,
  commission_pickup: null,
  category_id: null,
  category_name: null,
  category_item_sequence: null,
  picking_area: null,
  picking_sequence: null,
  return_policy: null,
};
